<div class="row">
  <div class="col-md-12">
    @if (form) {
      <form [formGroup]="form" (submit)="submit()">
        <div class="full-width d-flex-row">
          <label class="search-input-label full-width-sm d-flex required" [for]="$formFields.message">
            <span class="fw-bold">{{ 'add_comment' | translate }}</span
            ><span class="font-italic">&nbsp;{{ 'username_tag_comments' | translate: username }}</span>
          </label>
          <textarea
            placeholder=""
            id="message"
            name="message"
            rows="2"
            [formControlName]="$formFields.message"
            class="form-element w-100"
            [attr.aria-required]="true"
            aria-describedby="comment-message-error"
          ></textarea>
          <div id="comment-message-error">
            @if (form.disabled === false) {
              <app-form-field-error
                [formValidationRequest$]="formValidationRequest$"
                [field]="form.get($formFields.message)"
                [name]="$formFields.message"
                [label]="'comment' | translate"
              ></app-form-field-error>
            }
          </div>
        </div>
        @if ((userOrigin$ | async) === Origin.staff) {
          <ng-container *appHasPermissions="RequiredSecurities.MT_Manual_Finding_Review_Create">
            <ds-checkbox
              [formControlName]="$formFields.internal"
              [label]="'internal_only' | translate"
              data-test-id="internal-checkbox"
              class="me-auto"
            ></ds-checkbox>
          </ng-container>
        }
        <div class="full-width d-flex justify-content-end">
          <button type="button" class="btn btn-link fw-bold" (click)="clear()">
            <u>{{ 'clear_field_comment' | translate }}</u>
          </button>
          <button type="submit" class="btn fw-bold btn-outline-primary">
            {{ 'add_comment' | translate }}
          </button>
        </div>
      </form>
    }
  </div>
</div>
